export const API = {
  // public routes
  initialize: '/applicant/initialize',
  authenticate: '/applicant/authenticate',
  twoFactorValidate: '/applicant/api/two-factor/validate',
  impersonate: '/applicant/impersonate/user',
  logout: '/applicant/logout',
  deeplinkOrganization: '/applicant/deeplink/programSearch/organization',
  // secure routes have /api prefix
  authenticatedUser: '/applicant/api/authenticatedUser',
  preAuthenticate: '/applicant/api/preAuthenticate',
  preLoginFeature: '/applicant/api/preLoginFeature',
  applicationSwitches: '/applicant/api/applicationSwitches',
  forgotPassword: '/applicant/api/forgotPassword',
  instructions: '/applicant/api/instructions',
  footer: '/applicant/api/footer',
  logintext: '/applicant/api/logintext',
  casBranding: '/applicant/api/casBrandings',
  casLanguageTokens: '/applicant/api/langTokens',
  userAccount: '/applicant/api/userAccount',
  emailAvailability: '/applicant/api/emailAvailability',
  experiences: '/applicant/api/supportingInfo/experiences',
  mostImportantExperience: '/applicant/api/supportingInfo/experience',
  licenses: '/applicant/api/supportingInfo/licenses',
  licensesList: '/applicant/api/supportingInfo/licenses/blockName',
  memberships: '/applicant/api/supportingInfo/memberships',
  membershipTypes: '/applicant/api/lookup/membershipTypes',
  aptaMemberships: '/applicant/api/lookup/aptaMemberships',
  credentialsAndCertifications: '/applicant/api/supportingInfo/credentialsAndCertifications',
  lookupCredentialsAndCertifications: '/applicant/api/lookup/credentialsAndCertifications',
  conferencesAttended: '/applicant/api/supportingInfo/conferencesAttended',
  lookupLicensesTypes: '/applicant/api/lookup/license',
  lookupLicenses2Types: '/applicant/api/lookup/nursingLicenses',
  experiencesQuestionBlock: '/applicant/api/questionBlock/supportingInfo/experiences',
  validateResetLink: '/applicant/api/profile/validate',
  resetPassword: '/applicant/api/profile/changePassword',
  navigation: '/applicant/api/navigation',
  subSection: '/applicant/api/customQuestions/subSection',
  programNavigation: '/applicant/api/getProgramNavigation',
  programSections: '/applicant/api/getProgramSectionsDetails',
  extendedProfile: '/applicant/api/extendedProfile',
  questionAnswersIds: '/applicant/api/extendedProfile/questionAnswersIds',
  applicationImpactRules: '/applicant/api/extendedProfile/applicationProgramSelectionImpact',
  programSelectionSettings: '/applicant/api/programSelectionSettings',
  getAlternateProgramInstructions: '/applicant/api/getAlternateProgramInstructions',
  programFilters: '/applicant/api/search/filters',
  programDetails: '/applicant/api/program',
  programCardAttributes: '/applicant/api/getProgramCardsPageAttributes',
  programTableHeaderAttributes: '/applicant/api/getProgramHeaderPageAttributes',
  programSelection: '/applicant/api/programSelection',
  filteredQueries: '/applicant/api/search/filteredQueries',
  scrolls: '/applicant/api/search/filteredQueries/scrolls',
  programMaterials: '/applicant/api/programMaterials',
  programMaterialsTranscripts: '/applicant/api/programMaterials/prerequisites/transcripts',
  programPrerequisites: '/applicant/api/academicHistory/prerequisites',
  userProfile: '/applicant/api/userProfile',
  changePassword: '/applicant/api/userProfile/changePassword',
  highSchools: '/applicant/api/academicHistory/highSchools',
  saveCWEInfo: '/applicant/api/academicHistory/saveCWEInfo',
  highSchoolCourseWork: '/applicant/api/academicHistory/highSchoolCourseWork/highSchools',
  highSchoolCourse: '/applicant/api/academicHistory/highSchoolCourseWork1/gradeLevel/courses',
  highSchoolsGradeLevelList: '/applicant/api/lookup/highSchoolGradeLevels',
  highSchoolsGradeLevel: '/applicant/api/academicHistory/highSchoolCourseWork/gradeLevel',
  highSchoolsClassificationTypes: '/applicant/api/lookup/highSchoolClassificationTypes',
  highSchoolTermSubTypes: '/applicant/api/lookup/highSchoolTermSubTypes',
  lookupHighSchoolMixedGrades: '/applicant/api/lookup/highSchoolMixedGrades/HighSchool',
  lookupHighSchoolsCourses: '/applicant/api/academicHistory/highSchoolCourseWork/getHighSchoolCoursesFromCMP',
  highSchoolCourseEntryTypes: '/applicant/api/lookup/highSchoolCourseEntryTypes',
  highSchoolInfo: '/applicant/api/academicHistory/highSchoolInfo',
  colleges: '/applicant/api/academicHistory/colleges',
  courseWorkRequirements: '/applicant/api/academicHistory/transcriptRequirements',
  collegeCourseWork: '/applicant/api/academicHistory/courseWork',
  savePTEPaidCollege: '/applicant/api/academicHistory/savePTEPaidCollege',
  courses: '/applicant/api/academicHistory/courses',
  academicHistoryTranscripts: '/applicant/api/academicHistory/transcripts',
  courseWorkSummary: '/applicant/api/academicHistory/courseWork/summary',
  saveCWETranscriptReview: '/applicant/api/academicHistory/saveCWETranscriptReview',
  savePTEApproval: '/applicant/api/academicHistory/savePTEApproval',
  generalEducation: '/applicant/api/academicHistory/generalEducation',
  feeCalculation: '/applicant/api/feeCalculation',
  termAndCourses: '/applicant/api/saveOrUpdateTermAndCourses',
  paymentContactInformation: '/applicant/api/paymentContactInformation',
  payments: '/applicant/api/payments',
  lookupTerms: '/applicant/api/lookup/terms',
  lookupTermTypes: '/applicant/api/lookup/termType',
  lookupCollegeTuition: '/applicant/api/lookup/collegeTuition',
  lookupAnimalTypes: '/applicant/api/lookup/animalTypes',
  lookupExperienceTimeFrame: '/applicant/api/lookup/experienceTimeFrame',
  lookupExperienceCompetency: '/applicant/api/lookup/experienceCompetency',
  lookupExperienceDomain: '/applicant/api/lookup/experienceDomain',
  lookupMonths: '/applicant/api/lookup/month',
  lookupYears: '/applicant/api/lookup/year',
  lookupYearRangeByTerm: '/applicant/api/lookup/yearRangeByTerm',
  lookupAcademicStatus: '/applicant/api/lookup/academicStatus',
  lookupColleges: '/applicant/api/lookup/colleges',
  lookupMinors: '/applicant/api/lookup/collegeMinor',
  lookupSubjects: '/applicant/api/lookup/subjects',
  lookupDegreeTypes: '/applicant/api/lookup/degreeType',
  lookupDegreeStatus: '/applicant/api/lookup/degreeStatus',
  lookupCreditCardTypes: '/applicant/api/lookup/creditCardTypes',
  lookupCreditCardExpMonth: '/applicant/api/lookup/creditCardExpMonth',
  lookupCreditCardExpYear: '/applicant/api/lookup/creditCardExpYear',
  lookupCountries: '/applicant/api/lookup/countries',
  lookupStates: '/applicant/api/lookup/states',
  lookupEmploymentStatusTypes: '/applicant/api/lookup/employmentStatusTypes',
  lookupExperienceTypes: '/applicant/api/lookup/experienceTypes',
  lookupHighSchoolTermType: '/applicant/api/lookup/highSchoolTermTypes',
  transcripts: '/applicant/api/transcripts',
  transcriptRequestForm: '/applicant/api/transcriptRequestForm/colleges',
  lookupCounties: '/applicant/api/lookup/counties',
  lookupGender2Consider: '/applicant/api/lookup/LK_Gender2ConsiderYourself',
  lookupGender2Describe: '/applicant/api/lookup/LK_Gender2DescribeYourself',
  lookupGender2Express: '/applicant/api/lookup/LK_Gender2ExpressYourGender',
  lookupRelationship: '/applicant/api/lookup/relationship',
  lookupOccupation: '/applicant/api/lookup/occupation',
  lookupEducation: '/applicant/api/lookup/education',
  lookupCitizenshipStatus: '/applicant/api/lookup/citizenshipStatus',
  lookupResidencyDuration: '/applicant/api/lookup/residencyDuration',
  lookupVisaTypes: '/applicant/api/lookup/visaTypes',
  lookupGeographicArea: '/applicant/api/lookup/geoAreaEnvFactor',
  lookupIncomeLevel: '/applicant/api/lookup/incomeLevel',
  lookupCurrentMilitaryStatus: '/applicant/api/lookup/currentMilitaryStatus',
  lookupArmedForces: '/applicant/api/lookup/armedForces2',
  lookupEnrollMilitaryStatus: '/applicant/api/lookup/militaryStatus3',
  lookupMilitaryStatus2: '/applicant/api/lookup/militaryStatus2',
  lookupMilitaryStatus: '/applicant/api/lookup/militaryStatus',
  lookupInstitutionalEvaluationException: '/applicant/api/lookup/institutionEvaluationException',
  lookupInstitutionalEvaluations: '/applicant/api/lookup/institutionalEvaluations',
  lookupSocioEconomicIndicators: '/applicant/api/lookup/socioEconomicIndicators',
  lookupLanguages: '/applicant/api/lookup/languages',
  lookupGeoAreaRaised: '/applicant/api/lookup/geoAreaRaised',
  lookupUSArmedForces: '/applicant/api/lookup/armedForces',
  lookupMetriculatedProgramTypes: '/applicant/api/lookup/metriculatedProgramTypes',
  lookupSpecialityAreas: '/applicant/api/lookup/specialityAreas',
  lookupMedicalSchoolTypes: '/applicant/api/lookup/medicalSchoolType',
  lookupMedicalSchoolDegree: '/applicant/api/lookup/medicalSchoolDegree',
  lookupMedicalSchools: '/applicant/api/lookup/medicalSchools',
  lookupGpaDegrees: '/applicant/api/lookup/gpaDegrees',
  lookupEthnicity: '/applicant/api/lookup/LK_Ethnicity',
  lookupRace: '/applicant/api/lookup/LK_Race',
  lookupHispanicLatino: '/applicant/api/lookup/LK_HispanicLatino',
  checkAnalytics: '/applicant/api/checkHeapAndPendoImplementation',
  googleAnalytics: '/applicant/api/googleAnalytics',
  gradeConversion: '/applicant/api/gradeConversion',
  updateProgramSelection: '/applicant/api/updateProgramSelection',
  runProgramValidations: '/applicant/api/runProgramValidations',
  filteredQueriesByOrgId: '/applicant/api/search/deeplink/programs/filteredQueries',
  validateCoupon: '/applicant/api/validateCouponCodes',
  programsDisassociation: '/applicant/api/invitationCodes/programsDisassociation',
  submitProgramValidations: '/applicant/api/validateApplicationRules',
  deleteProgramsByIds: '/applicant/api/programselected/deleteByProgramIds',
  uploadTranscript: '/applicant/api/uploadTranscript',
  deleteTranscript: '/applicant/api/deleteTranscript',
  updateHighSchoolTranscriptCompletionStatus: '/applicant/api/updateHighSchoolTranscriptCompletionStatus',
  termInfoLookup: '/applicant/api/termInfoLookup',
  applicationSubSectionBlocks: '/applicant/api/applicationFormSubSectionBlocks/subSection',
  addressValidation: '/applicant/api/addressValidation',
  standardizedTests: '/applicant/api/academicHistory/standardizedTests',
  standardizedTestTypes: '/applicant/api/lookup/standardizedTestTypes',
  standardizedTestTypesDetails: '/applicant/api/standardTestTypesDetails',
  saveAlternateId: '/applicant/api/saveAlternateId',
  standardizedOrders: '/applicant/api/checkout/orders',
  callOfficialStandardizedTestsScores: '/applicant/api/callOfficialStandardizedTestsScores',
  officialStandardizedTests: '/applicant/api/officialStandardizedTests',
  officialStandardizedTestTypes: '/applicant/api/lookup/officialStandardizedTestTypes',
  updateChecklistStatus: '/applicant/api/updatecheckliststatus/subSection',
  medicalSchoolPerformanceEvaluation: '/applicant/api/supportingInfo/medicalSchoolEvaluation/subSection',
  medicalSchoolTranscripts: '/applicant/api/supportingInfo/medicalSchoolTranscriptEvaluation/subSection',
  notifications: '/applicant/api/notifications',
  notification: '/applicant/api/notification',
  viewTranscript: '/applicant/api/viewTranscript',
  achievements: '/applicant/api/supportingInfo/achievements',
  paymentsHistory: '/applicant/api/payments/history',
  achievementTypes: '/applicant/api/lookup/achievementTypes',
  evaluations: '/applicant/api/supportingInfo/evaluations',
  pooledEvaluation: '/applicant/api/pooledEvaluation',
  pooledEvaluationRequestId: '/applicant/api/evaluationRequest/evaluationRequestId',
  emailVerification: '/applicant/api/emailVerification/program',
  pooledEvaluationEmailVerification: '/applicant/api/emailVerification/pooledEvaluations/email',
  nmsMatchRegistration: '/applicant/api/nmsMatchRegistration',
  nmsMatchRegistrationHandShake: '/applicant/api/nmsMatchRegistrationHandShake',
  time2track: '/applicant/api/time2TrackRegistration',
  time2trackHandShake: '/applicant/api/time2Track/handshake',
  aimConnectorHandShake: '/applicant/api/aim/handshake',
  alignmentInsights: '/applicant/api/alignmentInsights',
  q3Documents: '/applicant/api/supportingInfo/documents',
  viewQ3Documents: '/applicant/api/supportingInfo/documents/view',
  institutionEvaluation: '/applicant/api/supportingInfo/institutionEvaluation',
  programEvaluations: '/applicant/api/programMaterials',
  applicantSuspension: '/applicant/api/applicantSuspension',
  applicantSuspensionDocuments: '/applicant/api/applicantSuspension/documents',
  viewApplicantSuspensionDocuments: '/applicant/api/applicantSuspension/documents/view',
  viewQ4Documents: '/applicant/api/programMaterials/documents',
  updateProgramMaterialStatus: '/applicant/api/updateProgramMaterialsStatus',
  signal: '/applicant/api/programMaterials/signal',
  applicationReview: '/applicant/api/reviewApplication',
  raceAndEthnicity: '/applicant/api/personalInfo/raceAndEthnicity',
  dashboardStatus: '/applicant/api/dashboardStatus',
  recommendations: '/applicant/api/recommendations',
  programStatus: '/applicant/api/programStatus',
  viewSelectedProgram: '/applicant/api/viewSelectedProgram',
  redeliverApplication: '/applicant/api/redeliverApplication',
  gdpr: '/applicant/api/gdpr',
  continuingCourses: '/applicant/api/academicHistory/continuingEducationCourses',
  programsSelected: '/applicant/api/programsSelected',
  pooledEvaluationDetails: '/applicant/api/pooledEvaluationDetails',
  pooledSections: '/applicant/api/getPooledProgramsInfo',
  pooledEvaluationProgramsByType: '/applicant/api/evaluationPool/evaluationType',
  pooledEvaluationProgramsByRequestId: '/applicant/api/evaluationPool/evaluationRequest',
  medicalSchools: '/applicant/api/academicHistory/medicalSchools',
  officialTestStatus: '/applicant/api/officialTestScoresStatus',
  twoFactorQRCode: `/applicant/api/two-factor/qr-code`,
  twoFactorSetEnabled: `/applicant/api/two-factor/set-enabled`,
  startFreshApplication: '/applicant/api/reApp/startFreshApplication',
  getReAppRolloverSections: '/applicant/api/reApp/getReAppRolloverSections',
  saveReAppRolloverSections: '/applicant/api/reApp/saveReAppRolloverSections',
  dataProcessed: '/applicant/api/reApp/dataProcessed',
  feeWaiver: '/applicant/api/feeWaiver',
  cancelFeeWaiver: '/applicant/api/cancelFeeWaiver',
  viewAttachment: '/applicant/api/viewAttachment',
  allCycleProgramPDFs: '/applicant/api/selectedProgramsHistory',
  dentPinExist: '/applicant/api/isDentPinExists',
  highSchoolSuggestions: '/applicant/api/search/highschoolLookup/suggestions',
  highSchoolsLookup: '/applicant/api/search/highschoollookup/highschools',
  residenciesAndFellowshipsTypes: '/applicant/api/lookup/residenciesAndFellowships',
  residenciesAndFellowships: '/applicant/api/supportingInfo/residenciesAndFellowships',
  nrmpExist: '/applicant/api/isNRMPExists',
  slideRoom: '/applicant/api/slideroom',
  getProgramSectionsInfo: '/applicant/api/getProgramSectionsInfo',
  gpaEntries: '/applicant/api/getApplicantTranscriptSummary',
  unofficialGPA: '/applicant/api/unofficialGPA',
  assistCoursesByTerm: '/applicant/api/academicHistory/ASSISTCoursesByTerm',
  adtEVerificationStatus: '/applicant/api/adtEVerificationStatus',
  saveAlternateProgram: '/applicant/api/saveAlternateProgram',
  csuAdmissionEligibilityStatus: '/applicant/api/csuAdmissionEligibilityStatus',
  recalculateTransferableGPA: '/applicant/api/recalculateTransferableGPA',
  getTransferableGPA: '/applicant/api/getTransferableGPA',
  springWinterRedirection: '/applicant/api/supportingInfo/applicantRedirection/springWinterRedirection',
  applicantRedirection: '/applicant/api/supportingInfo/applicantRedirection/',
  springRedirectionCampus: '/applicant/api/lookup/springRedirectionCampus',
  fallRedirectionCampus: '/applicant/api/lookup/fallRedirectionCampus',
  noRedirection: '/applicant/api/lookup/noRedirection',
  saveApplicantRedirection: '/applicant/api/supportingInfo/saveApplicantRedirection',
  csuFeeWaiverStatus: '/applicant/api/automaticFeeWaiver',
  validateApplication: '/applicant/api/validateApplication',
  lookupOHSubmissionTypes: '/applicant/api/lookup/ohSubmissionType',
  lookupOHRecognitionTypes: '/applicant/api/lookup/ohRecognitionType',
  lookupOHExperienceTypes: '/applicant/api/lookup/ohExperienceType',
  lookupOHRoleOfPersonShadowed: '/applicant/api/lookup/ohRoleOfPersonShadowed',
  lookupOHPatientDiagnoses: '/applicant/api/lookup/ohPatientDiagnoses',
  observationHours: '/applicant/api/supportingInfo/observationHours',
  uploadObservationHoursDocument: '/applicant/api/supportingInfo/observationHours/uploads',
};
